import React, { useEffect } from 'react'
import { View, Text, TextInput } from 'react-native'

import { formStyles } from './styles'
import { useValuesDeclareFailure } from '../../hooks/useValuesDeclareFailure'
import { handleFormatValue } from '../../helpers'
import { inputStyle } from '../../../../theme/inputs'
import { FailureValues } from '../../../../types'
import { useTranslation } from 'react-i18next'

interface Values {
  diver: string
  ship: string
  hydraulic: string
}

interface Props {
  initialValues?: FailureValues
  getValues: (values: FailureValues) => void
}
export const CategoryOneFailureForm = ({ getValues, initialValues }: Props) => {
  const { t } = useTranslation()
  const { values, handleAddSymbol, handleChange } = useValuesDeclareFailure<Values>({
    diver: initialValues?.diver ? `${initialValues?.diver}` : '',
    hydraulic: initialValues?.hydraulic ? `${initialValues?.hydraulic}` : '',
    ship: initialValues?.ship ? `${initialValues?.ship}` : '',
  })

  useEffect(() => {
    getValues({
      diver: handleFormatValue(values.diver),
      noRelief: null,
      hydraulic: handleFormatValue(values.hydraulic),
      ship: handleFormatValue(values.ship),
      dotation: null,
      work: null,
    })
  }, [values])

  return (
    <View style={formStyles.container}>
      <View style={{ marginVertical: 10 }}>
        <Text style={formStyles.label}>{t('BUZO')}</Text>
        <TextInput
          keyboardType='numeric'
          inputMode='numeric'
          onChangeText={(value) => handleChange(value, 'diver')}
          onEndEditing={(value) => handleAddSymbol(value.nativeEvent.text, 'diver')}
          value={values.diver}
          style={[inputStyle.basicInput]}
          placeholder='Ingrese % de falla'
        />
      </View>

      <View style={{ marginVertical: 10 }}>
        <Text style={formStyles.label}>{t('BARCO')}</Text>
        <TextInput
          keyboardType='numeric'
          inputMode='numeric'
          onChangeText={(value) => handleChange(value, 'ship')}
          onEndEditing={(value) => handleAddSymbol(value.nativeEvent.text, 'ship')}
          value={values.ship}
          style={[inputStyle.basicInput]}
          placeholder='Ingrese % de falla'
        />
      </View>

      <View style={{ marginVertical: 10 }}>
        <Text style={formStyles.label}>{t('HIDRÁULICO')}</Text>
        <TextInput
          keyboardType='numeric'
          inputMode='numeric'
          onChangeText={(value) => handleChange(value, 'hydraulic')}
          onEndEditing={(value) => handleAddSymbol(value.nativeEvent.text, 'hydraulic')}
          value={values.hydraulic}
          style={[inputStyle.basicInput]}
          placeholder='Ingrese % de falla'
        />
      </View>
    </View>
  )
}
